<p-multiSelect placeholder="Search" appendTo="body" tooltipPosition="bottom"
    matTooltip="Choose Columns" resetFilterOnHide="true" tooltipPosition="bottom" #multiSelect 
    styleClass="mat-raised-button" panelStyleClass="custom-height-panel" class="column-filter search-row-space" 
    [options]="options" [ngModel]="value"
    [virtualScroll]="true" [virtualScrollItemSize]="40" #multiSelectRef [autofocusFilter]="true" 
    (onChange)="onChange.emit($event)" [showToggleAll]="false">
    <ng-template #dropdownicon>
        <mat-icon class="burger-icon">view_week</mat-icon>
    </ng-template>
    <ng-template pTemplate="header">
        <div class="custom-multiselect-header">
            <button
                type="button"
                class="close-button"
                (click)="multiSelectRef.hide()"
                aria-label="Close"
            >
                <i class="pi pi-times"></i>
            </button>
        </div>
    </ng-template>
</p-multiSelect>
